export default __webpack_public_path__ + "static/media/support-icon.d1f59edc.png";